// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"567052d6","239":"5bf7d952","455":"6b6e2a00"}[chunkId] + ".chunk.js";
};